import { create } from "zustand";
import { apiRequest } from "@/lib/api";
import { getAccessToken } from "@/lib/auth";

export interface HistoryEntry {
  id: string;
  nodeId: string;
  nodeName: string;
  action: string;
  user: string;
  timestamp: string;
}

interface HistoryState {
  entries: HistoryEntry[];
  loading: boolean;
  loadFromAPI: () => Promise<void>;
  addEntry: (nodeId: string, nodeName: string, action: string, user: string) => void;
}

export const useHistoryStore = create<HistoryState>((set) => ({
  entries: [],
  loading: false,

  loadFromAPI: async () => {
    set({ loading: true });
    try {
      const token = getAccessToken();
      if (!token) {
        set({ loading: false });
        return;
      }

      const auditData = await apiRequest<any>("/v1/audit?limit=20");
      const userNames: Record<string, string> = {};

      try {
        const users = await apiRequest<any>("/v1/users");
        const userList = users?.items || users || [];
        if (Array.isArray(userList)) {
          userList.forEach((u: any) => {
            userNames[u.id] = u.name || u.email;
          });
        }
      } catch {
        // users optional
      }

      const rawEntries = auditData?.items || auditData || [];
      const entries: HistoryEntry[] = (Array.isArray(rawEntries) ? rawEntries : []).map((entry: any) => ({
        id: entry.id,
        nodeId: entry.resource_id,
        nodeName: entry.metadata?.title || entry.resource_type || "Item",
        action: entry.action,
        user: userNames[entry.actor_id] || "Sistema",
        timestamp: new Date(entry.created_at).toLocaleString(),
      }));

      set({ entries, loading: false });
    } catch {
      set({ loading: false });
    }
  },

  addEntry: (nodeId, nodeName, action, user) => {
    const entry: HistoryEntry = {
      id: `hist-${Date.now()}`,
      nodeId,
      nodeName,
      action,
      user,
      timestamp: "Ahora mismo",
    };
    set((s) => ({ entries: [entry, ...s.entries] }));
  },
}));